import React from "react";
import { Branding, IRightRailEntry } from '@emarketer/componentlibrary';
import { useStaticQuery, graphql } from "gatsby";
import {emConfig as  config } from "@/emConfiguration";


export interface BrandingProps {
  // set prop types if needed
  isHomepage?: boolean;
  isDualLogo?: boolean;
  showIntercom?: boolean;
}

export const Header: React.FC<{
  isHomepage?: boolean,
  showIntercom?: boolean
}>
  = ({
    isHomepage = false,
    showIntercom = false
  }) => {
    const rightRailQueryResult: {
      allBrandingAsset: {
        nodes: {
          head: string;
          subHead: string;
          url: string;
          publicationDateUtc: Date;
          assetType: string;
        }[]
      }
    } = useStaticQuery(graphql`
      query BrandingAssets {
        allBrandingAsset(
          sort: { publicationDateUtc: DESC}
          limit: 10
          ) {
          nodes {
            head
            subHead
            url
            publicationDateUtc
            assetType
          }
        }
      }
    `);

    const brandingAssets: IRightRailEntry[] = rightRailQueryResult.allBrandingAsset.nodes
      .map((item): IRightRailEntry => ({
        name: item.head,
        assetType: item.assetType,
        description: item.subHead,
        linkText: item.head,
        publicationDateUtc: item.publicationDateUtc,
        url: item.url
      }));


    return <div className="w-full">
      <Branding
        isHomepage={isHomepage}
        showIntercom={showIntercom}
        articlesServiceUrl={config.articlesServiceUrl}
        emHomeUrl={config.iiHomeUrl}
        researchTopicsServiceUrl={config.researchTopicsUrl}
        searchServiceUrl={config.searchRootUrl}
        noteworthyContentInjectable={config.noteworthyContentServiceUrl}
        noteworthyContentApiUrl={config.noteworthyContentApiUrl}
        typeaheadPluginUrl={config.typeaheadPluginUrl}
        loginUrl={config.subscriptionBaseUrl}
        intercomAppId={config.intercomAppId}
        osanoScriptUrl="" /* IMPORTANT: keep Osano blank. we want to inject it ourselves. */
        doesMyCompanyURL={config.doesmyCompanyPluginUrl}
        gaApiSecret={config.gaApiSecret}
        gaMeasurementId={config.gaMeasurementId}
        coverageRightRailItems={brandingAssets}
        enableRedirectionToProSiteOnLogin={false}
      />
    </div>;
  };

Header.defaultProps = {
  isHomepage: false,
  showIntercom: false
};
